import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

type TImgBlock = {
    webpImg?: string,
    pngImg?: string,
}

export const FeaturesBlock = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    grid-gap: 26px;
    background: #2d3443;
    border-radius: ${BorderRadius.OuterBlockRadius};
`;

export const ImgBlock = styled.div<TImgBlock>`
    flex-direction: column;
    height: 418px;
    width: auto;
    border-radius: ${BorderRadius.OuterBlockRadius};
    ${(props) => (props.pngImg || props.webpImg) && css`
    background-image: url('${useProgressiveImage(props.webpImg, { hasTimeout: true, timeoutDelay: 1 }, props.pngImg)}');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top;
`};
`;

export const TextBlock = styled.div<{ textColor?: string }>`
    width: auto;
    margin: 60% 28px auto 28px;
    color: ${({ textColor }) => textColor ?? COLORS.white};
`;

export const Title = styled.div`
    margin-bottom: 8px;
    ${FONTS.H3};
    color: ${COLORS.white};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const SubText = styled.div`
    ${FONTS.S};
    color: ${COLORS.white};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const NoSsrContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const FeaturesContainer = styled.div`
    width: 100%;
    box-sizing: content-box;
    margin: 32px 0;
    justify-content: center;
    flex-wrap: wrap;
`;

export const Button = styled(BaseButton)`
    width: 226px;
    height: 48px;
    margin: 13px auto 0 auto;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-top: 37px;
    };

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    };
`;
